export default __webpack_public_path__ + "static/media/wh.5d98453a.png";